export default __webpack_public_path__ + "static/painting6-4cc049955d9b6783fa1d9d308a9ac847.jpg";